import { writable } from 'svelte/store';

export const datagrid = writable([]);